export const states = [
  "AL",
  "AK",
  "AS",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "DC",
  "FM",
  "FL",
  "GA",
  "GU",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MH",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "MP",
  "OH",
  "OK",
  "OR",
  "PW",
  "PA",
  "PR",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VI",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY"
];

export const apiKey =
  new Date().getDay() === 0
    ? "48465f4e00msh99e7d8eb06aeaedp1d749djsn81db58168670"
    : new Date().getDay() === 1
    ? "7a9647ee1dmshe6c65a01be6b969p12dc02jsn43e9b069476a"
    : new Date().getDay() === 2
    ? "59174cafe0msh825f1b693bf97f9p1a5a38jsn5fd51c60ad8c"
    : new Date().getDay() === 3
    ? "def45c50bemshf514509e12991cep1bebc9jsn30ad06b548d8"
    : new Date().getDay() === 4
    ? "7d97802595mshbdc1adc0837ce39p17271ajsn9d3d638e7cf7"
    : new Date().getDay() === 5
    ? "cb14f97090msh2a8f1718fca89e8p114a29jsn5ea168cc6b59"
    : "029f0a957amsh185705875e99847p160d88jsn1f109735568a";
